import { defineStore } from 'pinia'
import { useHttpStore } from './http'

const TRUSTED_TOKEN_KEY = 'user-trusted-2fa'

export const useAuthStore = defineStore('auth', {
    state: () => {
        return {
            isAuthenticated: false,
            token: '',
            verifiedEmail: '',
            isAdmin: false,
            twoFactorChallenge: '',
            twoFactorCodeExpiresAt: 0,
            recoverPassword: {
                email: '',
                attempts: 0,
                maxAttempts: 3
            }
        }
    },
    getters: {
        hasToken: () => localStorage.getItem('user-token') !== null,
        getToken: state => state.token,
        getAuthenticatedStatus: state => state.isAuthenticated,
    },
    actions: {
        setStatusAuthentication(status) {
            this.isAuthenticated = status
        },
        setToken(token) {
            this.token = token
        },
        setIsAdmin(isAdmin) {
            this.isAdmin = Boolean(isAdmin)
        },
        setTwoFactorChallenge({ challenge, expire_time }) {
            this.twoFactorChallenge = challenge
            this.twoFactorCodeExpiresAt = challenge
                ? Date.now() + Number(expire_time) * 1000
                : 0
        },

        readTrustedToken() {
            return localStorage.getItem(TRUSTED_TOKEN_KEY) || undefined
        },
        setTrustedToken(token) {
            if (token) {
                localStorage.setItem(TRUSTED_TOKEN_KEY, token)
            }
        },
        clearTrustedToken() {
            localStorage.removeItem(TRUSTED_TOKEN_KEY)
        },
        setSession(data) {
            localStorage.setItem('user-token', data.access_token)
            this.setToken(data.access_token)
            this.setIsAdmin(data.user?.is_admin)
            this.setStatusAuthentication(true)
            this.setTwoFactorChallenge({ challenge: '', expire_time: 0 })
            this.setTrustedToken(data.trusted_token)
        },
        async validateToken() {
            const httpStore = useHttpStore()
            let isValid = false

            await httpStore.apiOAuth
                .get(`/validate-token`)
                .then(() => {
                    this.setStatusAuthentication(true)
                    isValid = true
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        this.setStatusAuthentication(false)
                    }

                    isValid = false
                })

            return isValid
        },
        setVerifiedEmail(email) {
            this.recoverPassword.email = email
        }
    },
    persist: true
})
